<app-profile-created class="profile-created-root" *transloco="let t">
  <app-main-header header>{{ t('create-account') }}</app-main-header>
  <app-header profileHeader>{{ t('profile-successfully-created') }}</app-header>
  <app-paragraph welcome>{{ t('welcome-user') }}
    <br><span class="business-name">{{ businessName }}</span>
    <span *ngIf="maxNameLength()" class="hovertext">{{ businessName }}</span>
  </app-paragraph>
  <app-rounded-image image [src]="businessPhoto" alt="{{ t('uploaded-image-alt') }}"></app-rounded-image>
  <div buttonSection>
    <app-primary-button id="lnr-invite-create-account" [routerLink]="'/'+RoutesKeys.VERIFICATION">
      {{ t('verify-account') }}
    </app-primary-button>
  </div>
</app-profile-created>
